var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TW1"},[_c('div',{staticClass:"TW1_left"},[_c('pre',[_vm._v("      "),_c('div',{staticClass:"TW1_left_div",domProps:{"innerHTML":_vm._s(this.text)}}),_vm._v("\n    ")])]),_c('div',{staticClass:"TW1_right"},[_c('img',{staticClass:"TW1_right_image",style:(_vm.TW1_right_image_style),attrs:{"src":_vm.imgUrl,"alt":"图片"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }